<label>
    <span class="_slider"></span>
    <ng-content></ng-content>
</label>